import React from 'react';
import PropTypes from 'prop-types';
import { useHistory } from 'react-router-dom';
import { useIntl } from 'react-intl';
import { makeStyles } from '@material-ui/core/styles';
import { IconButton, Tooltip } from '@material-ui/core';
import { getRTLPopperStyles } from '~/modules/common/util';
import { AddResourceIcon } from '~/modules/common/components/Icons';
import {
  PERIOD_SCALE_ENUM,
  DISPLAY_UNIT_ENUM
} from '~/modules/resourcing/common/enums';
import { useRedirectToAssignResource } from '~/modules/resourcing/hooks';

const useStyles = makeStyles(theme => ({
  addResourceRoot: {
    padding: theme.spacing(0.8),
    margin: -theme.spacing(0.5)
  }
}));

const useTooltipPopperStyles = makeStyles(theme => ({
  popper: () => ({
    ...getRTLPopperStyles({ theme }),
    display: 'flex'
  })
}));

export const ResourceMatchItemAddResourceButton = ({
  classes: classesOverride,
  dataQeId,
  resourceRequest,
  scale,
  displayUnit
}) => {
  const classes = useStyles({ classesOverride });
  const tooltipPopperClasses = useTooltipPopperStyles();
  const { formatMessage } = useIntl();
  const history = useHistory();
  const onAssignResourceAction = useRedirectToAssignResource({
    history,
    resourceRequest,
    isResourcingTab: false,
    scale,
    displayUnit
  });
  const addResourceTitle = formatMessage({
    id: 'resourceMatchItem.allocateResource'
  });
  const addResourceButtonDataQeId = dataQeId
    ? `${dataQeId}_ResourceMatchItemAddResourceButton`
    : undefined;

  return (
    <IconButton
      data-qe-id={addResourceButtonDataQeId}
      color="primary"
      className={classes.addResourceRoot}
      onClick={onAssignResourceAction}
      aria-label={addResourceTitle}
    >
      <Tooltip
        title={addResourceTitle}
        aria-label={addResourceTitle}
        aria-hidden={false}
        placement="bottom-start"
        classes={tooltipPopperClasses}
      >
        <AddResourceIcon />
      </Tooltip>
    </IconButton>
  );
};

ResourceMatchItemAddResourceButton.propTypes = {
  classes: PropTypes.object,
  dataQeId: PropTypes.string,
  resourceRequest: PropTypes.object.isRequired,
  scale: PropTypes.oneOf(Object.values(PERIOD_SCALE_ENUM)),
  displayUnit: PropTypes.oneOf(Object.values(DISPLAY_UNIT_ENUM))
};

export default ResourceMatchItemAddResourceButton;
